import { MultiSubmissionConfig } from '../types';

export const competition18MultiSubmissionConfig: MultiSubmissionConfig = {
  key: 'competition_18',
  title: 'Submit Project',
  submitLabel: 'Submit',
  description: 'Add your project details, slides, and video. * Required',
  fields: [
    {
      id: 'submission_title',
      type: 'text',
      label: 'Project title',
      required: true,
      placeholder: 'Enter your project title',
    },
    {
      id: 'brief_text',
      type: 'textarea',
      label: 'Project description',
      required: true,
      placeholder: 'Describe your project, approach, and expected impact.',
      maxWords: 180,
    },
    {
      id: 'presentation_pdf',
      type: 'file',
      label: 'Project slides (PDF)',
      required: true,
      accept: '.pdf,application/pdf',
      helpText: 'Required for the website preview.',
    },
    {
      id: 'no_ppt',
      type: 'checkbox',
      label: 'No PowerPoint version available — PDF only',
    },
    {
      id: 'presentation_ppt',
      type: 'file',
      label: 'PowerPoint slides (.ppt or .pptx)',
      required: true,
      waivedByCheckbox: 'no_ppt',
      accept: '.ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
      helpText: 'For downloading with animations and transitions.',
    },
    {
      id: 'track',
      type: 'select',
      label: 'Track',
      required: true,
      options: [
        { value: 'plant_controlled_environment', label: '🌾 Plant & Controlled Environment Systems' },
        { value: 'livestock_animal', label: '🐖 Livestock & Animal Systems' },
        { value: 'automation_robotics', label: '🤖 Automation, Robotics & Intelligent Machines' },
        { value: 'food_supply_chain', label: '📈 Food, Supply Chain & Agricultural Systems' },
      ],
    },
    {
      id: 'video_link',
      type: 'url',
      label: 'Link to video',
      required: true,
      placeholder: 'https://...',
      helpText: 'Your video should be 2 minutes long.',
    },
  ],
};
